import React, { useEffect, useRef, useState } from 'react'
import { FiMenu, FiSettings, FiLogOut, FiCreditCard, FiChevronDown } from 'react-icons/fi'
import { NavLink, useNavigate } from 'react-router-dom'
import useLogout from '../../../../hooks/useLogout'
import { Link } from 'react-router-dom'
import NavLinks from './NavLinks'
import { FiMoon, FiSun } from 'react-icons/fi'
import { useTheme } from '../../../../contexts/ThemeContext'
import { MdOutlineLiveHelp } from 'react-icons/md'
import { IoIosHelpCircleOutline, IoMdPerson } from 'react-icons/io'

const Navbar = ({ profileName, profileIcon, disable }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const dropdownRef = useRef(null)
  const navigate = useNavigate()
  const logout = useLogout()
  const { theme, toggleTheme } = useTheme()
  const profileMenu = [
    { to: "/userlist", icon: IoMdPerson, name: "Users" },
    { to: "/feedback", icon: MdOutlineLiveHelp, name: "Feedback" },
    { to: "/help", icon: IoIosHelpCircleOutline, name: "Help" },
    // {to: "/subscription", icon: FiSettings, name: "Subscription"},
    { to: "/settings", icon: FiSettings, name: "Settings" },
  ]



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [dropdownRef])

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen)
  const closeDropdown = () => setDropdownOpen(false)

  // Define the logout function
  const handleLogout = async () => {
    closeDropdown() // Ensure the dropdown is closed upon logout
    // Logout logic goes here (e.g., clear auth token, update state, redirect)
    await logout()
    navigate('/sign-out') // Redirect to sign-in page
  }

  const linkClassName = (baseClasses) =>
    `${baseClasses} ${disable ? 'pointer-events-none opacity-50' : ''}`

  return (
    // <nav className="bg-white">
    <nav className="bg-white dark:bg-slate-700 shadow-md h-14 px-4 lg:px-8 top-0 w-full z-20">
      <div className="flex items-center font-medium justify-between">
        <div className="md:w-auto w-full flex items-center">
          <Link
            to="/main"
            className="block text-xl text-blue-900 dark:text-white font-semibold"
            // target="_blank"
          >
            <img
              src="/logo.svg"
              alt="Company Logo"
              className="block h-14 mr-2 align-bottom"
            />
          </Link>

          {/* <NavLink
            to="/home"
            className="hidden lg:block text-xl text-blue-900 dark:text-white font-semibold"
            target="_blank"
          >
            Tran
            <span className="text-3xl text-black dark:text-amber-100">X</span>
            Energy
          </NavLink> */}
          {/* 
          <div className="text-3xl" onClick={() => setOpen(!open)}>
            <ion-icon name={`${open ? 'close' : 'menu'}`}></ion-icon>
          </div> */}
        </div>
        <ul className="md:flex hidden text-lg items-center gap-8 h-full">
          {disable !== false && (
            <>
              {/* <li>
                <Link
                  to="/main"
                  className="flex items-center justify-center hover:bg-mainbg dark:text-gray-300 dark:hover:bg-maindarkbg px-3 inline-block h-14 text-base rounded-t-md"
                >
                  Dashboard
                </Link>
              </li> */}

              <li>
                <div>
                  <div className="px-3 text-center group">
                    <span
                      className="cursor-pointer hover:bg-mainbg h-14 px-3 rounded-t-md dark:text-gray-300 dark:hover:bg-maindarkbg flex justify-between items-center text-center text-base md:pr-0 group"
                    >
                      Hierarchy
                      <span className="text-xl md:ml-2 md:mr-2 group-hover:rotate-180">
                        <FiChevronDown />
                      </span>
                    </span>
                    <div>
                      <div className="absolute top-15 w-[220px] hidden shadow-lg group-hover:md:block hover:md:block">
                        <div className="py-3 mt-2 bg-white rounded-md py-5 pl-2 pr-4 grid grid-cols-1 gap-2">
                          <Link className="flex items-center dark:text-black justify-center mb-2" to="/hierarchy">
                            <span className="text-lg hover:underline">Site Hierarchy</span>
                          </Link>
                          <Link className="flex items-center dark:text-black justify-center" to="/org-boundary">
                            <span className="text-lg hover:underline text-center">Organizational Boundary</span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              {/* Emission Dropdown */}
              <NavLinks />

              <li>
                <Link
                  to="/analytics"
                  className="flex items-center justify-center hover:bg-mainbg dark:text-gray-300 dark:hover:bg-maindarkbg px-3 inline-block h-14 text-base rounded-t-md"
                >
                  Analytics
                </Link>
              </li>

              <li>
                <div>
                  <div className="px-3 text-center group">
                    <span
                      className="cursor-pointer hover:bg-mainbg h-14 px-3 rounded-t-md dark:text-gray-300 dark:hover:bg-maindarkbg flex justify-between items-center text-center text-base md:pr-0 group"

                    >
                      Recommendation
                      <span className="text-xl md:ml-2 md:mr-2 group-hover:rotate-180">
                        <FiChevronDown />
                      </span>
                    </span>
                    <div>
                      <div className="absolute top-15 right-45 w-[180px] hidden shadow-lg group-hover:md:block hover:md:block">
                        <div className="py-3 mt-2 bg-white rounded-md py-5 pl-2 pr-8 grid grid-cols-2">
                          <Link className="col-span-2 ml-6 flex items-center dark:text-black justify-center mb-3" to="/vendors">
                            <span className="text-lg hover:underline">Vendors</span>
                          </Link>
                          <Link className="col-span-2 ml-6 flex items-center dark:text-black justify-center mb-3" to="/research">
                            <span className="text-lg hover:underline">Research</span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </>
          )}

          <li className="flex items-center">
            <button
              onClick={toggleTheme}
              className="relative flex items-center justify-center bg-slate-300 dark:bg-gray-600 p-1 rounded-full hover:bg-gray-300 dark:hover:bg-gray-500 transition-colors duration-500 w-12 h-6"
            >
              <span
                className={`absolute ${theme === 'dark' ? 'left-1' : 'right-1'
                  } w-4 h-4 rounded-full shadow-md transform transition-transform duration-200`}
              ></span>
              {theme === 'dark' ? (
                <FiMoon
                  className="text-transparent fill-cyan-400 absolute left-1"
                  size={16}
                />
              ) : (
                <FiSun className="text-blue-700 absolute right-1" size={16} />
              )}
            </button>
          </li>

          <li className="relative" ref={dropdownRef}>
            <div
              className="flex items-center cursor-pointer md:block-hidden"
              onClick={toggleDropdown}
            >
              {profileIcon ? (
                <img
                  src={profileIcon}
                  alt="Profile"
                  className="rounded-full border border-gray-300 dark:border-gray-600"
                />
              ) : (
                <div className="flex justify-center items-center w-8 h-8 rounded-full bg-blue-500 text-white">
                  {profileName.charAt(0)}
                </div>
              )}
            </div>
            {dropdownOpen && (
              <div className="absolute right-0 w-48 bg-gray-500 dark:bg-gray-300 mt-3 rounded-md shadow-xl z-20">
                <div className="text-white dark:text-black my-3 text-center text-sm font-normal">
                  {profileName}
                </div>
                {disable !== false &&
                  profileMenu.map((row, i) => (
                    <NavLink
                      key={i}
                      to={row.to}
                      className={linkClassName(
                        'block bg-white px-4 py-2 font-medium text-sm text-gray-700 hover:bg-blue-500 hover:text-white',
                      )}
                      onClick={(e) => {
                        disable && e.preventDefault()
                        closeDropdown()
                      }}
                    >
                      <row.icon className="inline mr-2" /> {row.name}
                    </NavLink>
                  ))
                }

                <NavLink
                  to="/sign-out"
                  className="block bg-white font-medium rounded-b-md px-4 py-2 text-sm text-gray-700 hover:bg-blue-500 hover:text-white"
                  onClick={handleLogout}
                >
                  <FiLogOut className="inline mr-2" /> Sign Out
                </NavLink>
              </div>
            )}
          </li>
        </ul>

        {/* <div className="flex">
          /* Mobile Nav
          <ul
            className={`
        md:hidden bg-white fixed w-full top-0 overflow-y-auto bottom-0 py-24 pl-4
        duration-500 ${open ? 'left-0' : 'left-[-100%]'}
        `}
          >
            <li>
              <Link to="/" className="py-7 px-3 inline-block">
                Home
              </Link>
            </li>
            <NavLinks />
          </ul>
        </div> */}
      </div>
    </nav>
  )
}

export default Navbar
